import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=f7b26018&ts=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__